import type { GroupEmployeeItem, LC_GroupEmployeeItem } from '../types/groupEmployees.types';


export function mapGroupEmployeeItem(transport: LC_GroupEmployeeItem): GroupEmployeeItem {
  return {
    employeeId: transport.employeeId,
    employeeName: transport.employeeName?.trim() ?? '',
    employeeTaxIdentificationNumber: transport.employeeTaxIdentificationNumber?.trim() ?? '',
  };
}
